import { lazy } from "react"
import { ITEM_TYPE } from "store/apis/storeAPI/values"
import { CURRENCY } from "store/apis/balanceAPI/values"
import { IApparelInstance } from "store/apis/apparelAPI"
import { IRuneInstance } from "store/apis/runesAPI/types"
import { IToolInstance } from "store/apis/toolsAPI/types"
import { IRecipeInstance } from "store/apis/recipeAPI/types"
import { ISaleChestInstance } from "store/apis/saleChestAPI"
import { IElixirInstance } from "store/apis/elixirsAPI/types"
import { IPreformInstance } from "store/apis/preformAPI/types"
import { IMissionChestInstance } from "store/apis/missionsAPI/types"

export const INVENTORY_MODALS = {
  shopItem: {
    component: lazy(() => import("modals/ui/inventory/ShopItemModal")),
    params: {} as {
      itemType: ITEM_TYPE
      item:
        | IToolInstance
        | IRuneInstance
        | IPreformInstance
        | ISaleChestInstance
        | IMissionChestInstance
        | IApparelInstance
        | IElixirInstance
      isBuying: boolean
      isUpdating?: boolean
      currentPrice?: number
      shopItemId?: string
      itemId?: string
      currency?: CURRENCY
      acceptOffers?: boolean
    }
  },
  preformDetails: {
    component: lazy(() => import("modals/ui/inventory/PreformDetails")),
    params: {} as {
      currPreform: IPreformInstance
    }
  },
  toolDetails: {
    component: lazy(() => import("modals/ui/inventory/ToolDetails")),
    params: {} as {
      currTool: IToolInstance
    }
  },
  putRuneIntoTool: {
    component: lazy(() => import("modals/ui/inventory/PutRuneIntoTool")),
    params: {} as {
      currTool: IToolInstance
      equippedRunes: IRuneInstance[]
    }
  },
  runeDetails: {
    component: lazy(() => import("modals/ui/inventory/RuneDetails")),
    params: {} as {
      currRune: IRuneInstance | null
      description?: string
      backToInventory?: () => void
    }
  },
  inventorySelectToSell: {
    component: lazy(
      () => import("modals/ui/inventory/InventorySelectToSellModal")
    ),
    params: {} as {
      currType: ITEM_TYPE
    }
  },
  selectItemToCraft: {
    component: lazy(() => import("modals/ui/inventory/SelectItemToCraft")),
    params: {} as {
      craftItemType: "rune" | "tool"
      setItemToCraft: (ids: (IToolInstance | IRuneInstance)[]) => void
      selectItems: (IToolInstance | IRuneInstance)[]
    }
  },
  selectRecipeToCraft: {
    component: lazy(() => import("modals/ui/inventory/SelectRecipeToCraft")),
    params: {} as {
      setRecipeToCraft: (recipe: IRecipeInstance | null) => void
      selectRecipe: IRecipeInstance | null
    }
  },
  preformInfo: {
    component: lazy(() => import("modals/ui/inventory/PreformInfo"))
  },
  saleChestDetails: {
    component: lazy(() => import("modals/ui/inventory/SaleChestDetails")),
    params: {} as {
      chestInstance: ISaleChestInstance & { imgSrc?: string }
    }
  },
  missionChestInventoryDetails: {
    component: lazy(
      () => import("modals/ui/inventory/MissionChestInventoryDetails")
    ),
    params: {} as {
      chestInstance: IMissionChestInstance
    }
  }
} as const
